import Vue, { VueConstructor } from 'vue';
import { Store } from 'vuex';
import { State } from './store';

abstract class VueStrongClass extends Vue {
  public $store!: Store<State>;
}

export default Vue as VueConstructor<VueStrongClass>;
